import { render } from "./inactive-dashboards-overview.vue?vue&type=template&id=0f6c4282&ts=true"
import script from "./inactive-dashboards-overview.ts?vue&type=script&lang=ts&external"
export * from "./inactive-dashboards-overview.ts?vue&type=script&lang=ts&external"

import "./inactive-dashboards-overview.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__